(function () {
  'use strict';
  if (customElements.get('bnx-cart-share') || !window.BnxCartShareCore) return;
  const Core = window.BnxCartShareCore;
  const PREFIX = '#bnx-cart=', JOURNAL = 'bnx-cart-share-operation-v1';
  const node = (tag, text) => { const el = document.createElement(tag); if (text !== undefined) el.textContent = text; return el; };
  class CartShare extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('hashchange', this.onHash);
        document.addEventListener('click', this.onLaunch);
        this.reveal.observe(document.body, {childList: true, subtree: true});
        this.loadLink();
        return;
      }
      this.initialized = true;
      this.shop = this.dataset.shop;
      this.cartPath = this.dataset.cartPath || '/cart';
      this.dialog = this.querySelector('dialog');
      this.onLaunch = event => {
        const button = event.target.closest('[data-bnx-share-trigger]');
        if (!button) return;
        event.preventDefault();
        this.returnFocus = button;
        this.share();
      };
      document.querySelectorAll('[data-bnx-share-trigger]').forEach(b => { b.hidden = false; });
      document.addEventListener('click', this.onLaunch);
      this.reveal = new MutationObserver(() => document.querySelectorAll('[data-bnx-share-trigger][hidden]').forEach(b => { b.hidden = false; }));
      this.reveal.observe(document.body, {childList: true, subtree: true});
      this.querySelector('[data-share-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('cancel', e => { if (this.busy && !this.generating) e.preventDefault(); else this.close(); });
      this.part('copy').addEventListener('click', () => this.copy());
      this.dialog.addEventListener('close', () => this.returnFocus?.isConnected && this.returnFocus.focus());
      this.onHash = () => this.loadLink();
      window.addEventListener('hashchange', this.onHash);
      this.loadLink();
    }
    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHash);
      document.removeEventListener('click', this.onLaunch);
      this.reveal?.disconnect();
    }
    part(name) { return this.querySelector(`[data-share-${name}]`); }
    message(text, error = false) { const el = this.part('message'); el.textContent = text; el.toggleAttribute('data-error', error); }
    busyState(value) {
      this.busy = value;
      this.dialog.setAttribute('aria-busy', String(value));
      this.querySelectorAll('button').forEach(b => { b.disabled = value && !(this.generating && b.hasAttribute('data-share-close')); });
    }
    open(title, description, show = true) {
      this.part('title').textContent = title;
      this.part('description').textContent = description;
      this.part('preview').replaceChildren(); this.part('actions').replaceChildren();
      this.part('link-box').hidden = true; this.part('hint').hidden = true; this.part('copy').textContent = 'Copy Link'; this.message('');
      if (show) this.show();
    }
    show() { if (!this.dialog.open) this.dialog.showModal(); this.part('title').focus(); }
    close() {
      if (this.busy && !this.generating) return;
      if (this.generating) { this.generation = (this.generation || 0) + 1; clearTimeout(this.loadingTimer); this.generating = false; this.busyState(false); }
      this.dialog.close();
    }
    action(label, handler, secondary = false) {
      const b = node('button', label); b.type = 'button'; b.toggleAttribute('data-secondary', secondary);
      b.addEventListener('click', handler); this.part('actions').append(b); return b;
    }
    preview(items) {
      for (const item of items) {
        const row = node('div'); row.className = 'bnx-share-item';
        row.append(node('p', `${item.title} × ${item.quantity}`));
        const props = Object.entries(item.properties).filter(([k]) => !k.startsWith('_'));
        if (props.length) {
          const details = node('details'), list = node('dl');
          details.append(node('summary', 'View saved options'));
          for (const [key, value] of props) {
            const pair = node('div'); pair.append(node('dt', key + ': '), node('dd', value)); list.append(pair);
          }
          details.append(list); row.append(details);
        }
        this.part('preview').append(row);
      }
    }
    async request(endpoint, body) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        // Let YMQ reconcile only after the complete operation, not between its parent/child lines.
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + endpoint + '?ymq-no-listen=true', {
          method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: {'Accept': 'application/json', ...(body ? {'Content-Type': 'application/json'} : {})},
          ...(body ? {body: JSON.stringify(body)} : {})
        });
        let result; try { result = await response.json(); } catch { throw new Error('The store returned an unexpected response. Please reload your cart.'); }
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'The store could not update these items. Please check availability.');
        return result;
      } catch (error) {
        if (error.name === 'AbortError') throw new Error('The store took too long to respond. Please review your cart before trying again.');
        throw error;
      } finally { clearTimeout(timeout); }
    }
    async share() {
      if (this.busy) return;
      const generation = this.generation = (this.generation || 0) + 1;
      this.open('Share your cart', '', false);
      this.dialog.dataset.mode = 'share';
      this.generating = true; this.busyState(true);
      this.loadingTimer = setTimeout(() => {
        if (generation !== this.generation) return;
        this.dialog.dataset.mode = 'loading';
        this.message('Generating sharing link...'); this.show();
      }, 350);
      try {
        if (window.BnxCartPage) await window.BnxCartPage.settle();
        const snapshot = Core.snapshot(await this.request('cart.js'), this.shop);
        const token = await Core.encode(snapshot);
        if (generation !== this.generation) return;
        clearTimeout(this.loadingTimer);
        const link = new URL(this.cartPath, location.origin);
        link.hash = 'bnx-cart=' + token;
        this.dialog.dataset.mode = 'share';
        this.part('link').value = link.href; this.part('link-box').hidden = false;
        this.part('hint').hidden = false;
        this.message(''); this.show();
      } catch (error) {
        if (generation !== this.generation) return;
        clearTimeout(this.loadingTimer); this.dialog.dataset.mode = 'error';
        this.message(error.message, true); this.action('Close', () => this.close(), true); this.show();
      } finally {
        if (generation === this.generation) { clearTimeout(this.loadingTimer); this.generating = false; this.busyState(false); }
      }
    }
    async copy() {
      try {
        await navigator.clipboard.writeText(this.part('link').value);
        this.part('copy').textContent = 'Copied'; this.message('');
      } catch {
        this.part('link').focus(); this.part('link').select();
        try { if (!document.execCommand('copy')) throw new Error(); this.part('copy').textContent = 'Copied'; this.message(''); }
        catch { this.message('Select and copy the entire link above.'); }
      }
    }
    readRecord() {
      try { return JSON.parse(sessionStorage.getItem(JOURNAL) || 'null'); }
      catch { throw new Error('Enable browser session storage before restoring a cart.'); }
    }
    async tokenId(token) {
      const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
      return Array.from(new Uint8Array(hash), v => v.toString(16).padStart(2, '0')).join('');
    }
    viewCart() { location.assign(new URL(this.cartPath, location.origin).href); }
    async loadLink() {
      if (this.busy || !location.hash.startsWith(PREFIX)) return;
      const token = location.hash.slice(PREFIX.length);
      this.open('You want', ''); this.dialog.dataset.mode = 'restore'; this.busyState(true);
      try {
        this.saved = await Core.decode(token, this.shop);
        this.operationId = await this.tokenId(token);
        const previous = this.readRecord();
        if (previous?.shop === this.shop && (previous.state === 'pending' || previous.state === 'uncertain' || previous.id === this.operationId)) {
          this.message(previous.state === 'done' ? 'This saved cart has already been loaded in this browser session. View your cart to avoid adding it twice.' : 'An earlier cart restore may have only partly completed. Please view and check your current cart; this link will not automatically retry.', previous.state !== 'done');
          this.part('description').textContent = 'Check your current items first. Starting a new merge will add the saved quantities again.';
          this.action('View current cart', () => this.viewCart());
          this.action('I checked my cart — review saved items', () => {
            try { sessionStorage.removeItem(JOURNAL); this.loadLink(); }
            catch { this.message('Enable browser session storage before restoring a cart.', true); }
          }, true);
          return;
        }
        const current = await this.request('cart.js');
        this.expected = Core.lines(current.items, true);
        this.action('Merge with current cart', () => this.restore('merge'));
        const separator = node('span', 'or'); separator.className = 'bnx-share-or'; this.part('actions').append(separator);
        this.action('Replace current cart', () => this.restore('replace'));

      } catch (error) {
        this.part('description').textContent = 'Your cart has not been changed.';
        this.message(error.message, true); this.action('Close', () => this.close(), true);
      } finally { this.busyState(false); }
    }
    async restore(mode) {
      if (this.busy) return;
      this.busyState(true); this.message('Restoring your selections. Please keep this window open…');
      let success = false;
      try {
        // Serializes this feature across same-origin tabs where Web Locks are supported.
        const run = async () => {
          const prior = this.readRecord();
          if (prior?.shop === this.shop && prior.id === this.operationId && prior.state) throw new Error('This restore was already started. Please view your cart first.');
          await Core.restore(this.saved.items, mode, {
            get: () => this.request('cart.js'),
            add: items => this.request('cart/add.js', {items}),
            update: updates => this.request('cart/update.js', {updates})
          }, record => {
            if (record) sessionStorage.setItem(JOURNAL, JSON.stringify({...record, shop: this.shop, id: this.operationId}));
            else sessionStorage.removeItem(JOURNAL);
          }, this.expected);
        };
        if (navigator.locks) await navigator.locks.request('bnx-cart-share-restore', run);
        else await run();
        success = true;
        this.message('Cart restored. Opening your cart…');
        // A full reload lets the theme and YMQ render the completed cart together.
        this.viewCart();
      } catch (error) {
        this.message(error.cartMayHaveChanged
          ? error.message + ' Some changes may already have been saved. Open your cart and check the items and quantities; no automatic retry will run.'
          : error.message, true);
        this.part('actions').replaceChildren();
        this.action('View current cart', () => this.viewCart());
        this.action('Close', () => this.close(), true);
      } finally { if (!success) this.busyState(false); }
    }
  }
  customElements.define('bnx-cart-share', CartShare);
})();
